/**
 * Normalizes delivery address payloads from admin/user APIs (mixed snake_case / camelCase).
 */

export interface NormalizedUserDeliveryAddress {
  id: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  isDefault: boolean;
}

function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}

export function normalizeDeliveryAddress(
  raw: unknown,
): NormalizedUserDeliveryAddress | null {
  if (!isRecord(raw)) return null;
  const id = raw.id ?? raw._id ?? raw.addressId;
  const street = raw.street;
  const postalCode =
    raw.postalCode ?? raw.postal_code ?? raw.zipCode ?? raw.zip_code;
  const city = raw.city;
  const country = raw.country ?? "Sverige";
  const isDefault = raw.isDefault ?? raw.is_default ?? false;

  if (
    id == null ||
    street == null ||
    postalCode == null ||
    city == null ||
    id === "" ||
    street === "" ||
    postalCode === "" ||
    city === ""
  ) {
    return null;
  }

  return {
    id: String(id),
    street: String(street),
    postalCode: String(postalCode),
    city: String(city),
    country: String(country),
    isDefault: Boolean(isDefault),
  };
}
